var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTringleProptech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 120,
    viewBox: "0 0 69 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3492 51.4565L66.6145 51.8709C68.1176 54.2202 69.0002 57.0051 69.0002 60.0008C69.0002 62.9967 68.1176 65.7808 66.6145 68.1304L66.3492 68.5459L33.5412 120H0.47168L55.2557 34.0583L66.3492 51.4565Z",
    fill: "url(#paint0_linear_1943_5747)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3492 68.5433L66.6145 68.1284C68.1176 65.7788 69.0002 62.9947 69.0002 59.9989C69.0002 57.0031 68.1176 54.2183 66.6145 51.869L66.3492 51.4546L33.5412 -0.000478597H0.47168L55.2557 85.9414L66.3492 68.5433Z",
    fill: "#EF3620"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1943_5747",
    x1: -6.33621,
    y1: 109.322,
    x2: 71.572,
    y2: 59.6463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794511,
    stopColor: "#B32422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B32422"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTringleProptech);
export default __webpack_public_path__ + "static/media/ic-tringle-proptech.5f0a0bc6a7219bd7c6c2a72cb9597aee.svg";
export { ForwardRef as ReactComponent };